export const passwordRuleText =
  "A senha deve conter no mínimo 8 caracteres, 1 letra maiúscula e 1 símbolo";

export const defaultErrorText =
  "Ops, algo deu errado. Tente novamente em alguns instantes. Se o problema persistir, entre em contato com: suporte@notepay.com";
